var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSamoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.384-114.616 256-256 256s-256-114.616-256-256c87.93-87.93 162.504-162.504 256-256 141.384 0 256 114.616 256 256z",
    fill: "#d80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256 256c0-141.384 0-158.052 0-256-141.384 0-256 114.616-256 256z",
    fill: "#0052b4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m205.054 166.957 4.145 12.755h13.41l-10.85 7.881 4.145 12.755-10.85-7.883-10.85 7.883 4.145-12.755-10.85-7.881h13.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.698 66.783 6.907 21.259h22.352l-18.084 13.135 6.909 21.258-18.084-13.139-18.083 13.139 6.908-21.258-18.083-13.135h22.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.481 89.043 6.907 21.26h22.351l-18.083 13.135 6.907 21.258-18.082-13.139-18.083 13.139 6.908-21.258-18.083-13.135h22.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.693 178.087 6.908 21.259h22.35l-18.083 13.135 6.908 21.258-18.083-13.138-18.083 13.138 6.908-21.258-18.083-13.135h22.351z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.176 122.435 6.908 21.259h22.351l-18.084 13.135 6.908 21.258-18.083-13.138-18.082 13.138 6.907-21.258-18.082-13.135h22.35z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamoa);
export default __webpack_public_path__ + "static/media/samoa.b917aace43bfde3d2823bc1abaddd8f7.svg";
export { ForwardRef as ReactComponent };